module.exports = __webpack_public_path__ + "static/media/arrcheologist.72595a89.jpg";